import { BankIdPaymentsActionTypes } from "models/actionTypes/bankIdPaymentsActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const bankIdPaymentReportUpdated = (
  bankIdPayments: WintSuperkollAPIModel.PaymentSigningInformation
): BankIdPaymentsActionTypes => {
  return {
    type: ReduxConstants.BankIdPaymentsActions.BANK_ID_PAYMENTS_REPORT_UPDATED,
    payload: bankIdPayments,
  };
};

export const bankIdPaymentReportCompleted = (id: number): BankIdPaymentsActionTypes => {
  return {
    type: ReduxConstants.BankIdPaymentsActions.BANK_ID_PAYMENTS_REPORT_COMPLETED,
    payload: id,
  };
};
